<script>
import { loading } from '@/shared/utils/UIHelper'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import Tools from '@/components/tools/Tools.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import lotPdf from '@/views/private/finance/expenses/travelexpensezpag/components/Tabs/CollaboratorTableTravelExpense/components/CollaboratorTableTravelExpenseEmploye/components/lotPdf.vue'

const name = 'detailsModal'

export default {
  name,
  mixins: [ActionsForm],
  components: { lotPdf },

  props: {
    partId: {
      typeof: String,
      default: ''
    },
    partStartDate: {
      typeof: String,
      default: ''
    },
    partEndDate: {
      typeof: String,
      default: ''
    },
    partNumber: {
      typeof: Number,
      default: 0
    },
    collabId: {
      typeof: String,
      default: ''
    },
    localidade: {
      typeof: String,
      default: ''
    },
    totalPartValue: {
      typeof: Number,
      default: 0
    }
  },

  mounted () {
  },

  updated () { },

  data () {
    return {
      expenses: [],
      expensesReport: [],
      nomeArquivo: ''
    }
  },

  methods: {
    async  getDetilsByPartId (id) {
      loading.push()
      await TravelExpenseRepository.GetExpenseDetailsByLoteId({ID: id, Valor: 0, funcionarioID: this.collabId, EmpresaID: this.CompanySelected}, this.$refs.partDetailsTab.pagingLimit, this.$refs.partDetailsTab.pagingIndex)
        .then((Response) => {
          this.expenses = Response.data.data
          this.$refs.partDetailsTab.LoadAllByData(Response)
        })
        .catch(() => {})
        .finally(() => { loading.pop() })
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    onLoad () {
      this.getDetilsByPartId(this.partId)
    },
    Download (obj) {
      this.nomeArquivo = obj.nomeArquivo
      loading.push()
      TravelExpenseRepository.Download(obj.midiaId, this.CompanySelected)
        .then((Response) => {
          const linkDownload = document.createElement('a')
          linkDownload.href = `data:image/png;base64,${Response.data}`
          linkDownload.download = this.nomeArquivo
          linkDownload.click()
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    GetEmpresa () {
      TravelExpenseRepository.GetEmpresa(this.CompanySelected)
        .then(Response => {
          this.local = Response.data.localidade
        })
    },
    getDownloadPDf () {
      this.$refs.lotpdf.onLoad()
    }
  },
  computed: { }

}
</script>

<template>
    <div class="details-modal">
    <h4 class="label mb-2"><strong>Lote: {{partNumber}}</strong></h4>
    <div class="date">
                  <div class="date-container">
                    <div class="date-content" style="width:25%">
                      <h5>Data Início:</h5>
                      <h6>{{partStartDate}}</h6>
                    </div>
                    <div class="date-content" style="width:75%">
                      <h5>Data Encerramento:</h5>
                      <h6>{{partEndDate}}</h6>
                    </div>
                  </div>
                  <div>
                    <div class="button-container-download" v-b-tooltip.hover title="Download Relatório" @click="getDownloadPDf">
                      <button type="button" class="button-back" ><i style="font-size:16px;padding-top:2px" class="fa fa-download "></i></button>
                    </div>
                  </div>
              </div>
    <Tables :stickyHeader="true" ref="partDetailsTab"
                  :columns="['Categoria','Subcategoria','Quantidade','Data da Despesa','Valor', '']"
                  :showSearch="false"
                  :showPrint="false"
                  :showDownload="false"
                  :showFullscreen="false"
                  v-on:Load="onLoad"
                  :key="0"
                >
                  <tr v-for="(expense,index) in expenses" :key="index" >
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="expense.categoria"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="expense.subCategoria ? expense.subCategoria : expense.subCategoriaVeiculo"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="expense.quantidade"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="expense.dataRegistroDespesa"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="formatMoney(expense.valor)"
                    />
                    <TableColumn
                      :IsLotDetail="true"
                      :HasDownloadUnico="true"
                      @Download="Download(expense)"
                      :status="1"
                    />
                  </tr>
        </Tables>
         <div class="total-container">
            <h4 class="label-total mb-2"><strong>Total: {{ formatMoney(totalPartValue) }}</strong></h4>
         </div>
         <lotPdf ref="lotpdf" :partId="partId" :collabId="collabId"></lotPdf>
    </div>
</template>

<style scoped>
.date{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
}
.date-container{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.details-modal{
  padding:1.2rem;
}
.label-total{
  padding: 0 1.2rem 0 1.2rem;
}
.total-container{
  display: flex;
  width: 100%;
  height: 100%;
  align-content: center;
  justify-content: flex-end;
}
.button-container-download{
  display: flex;
  align-items: center;
  width: 3rem;
}
.button-back{
  width: 4rem;
  border-radius: 5px;
  background-color: #008148;
  color: #fff;
  border: 0;
  height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/CollaboratorTableTravelExpense/components/CollaboratorTableTravelExpenseEmploye/components/detailsModal.vue